import { Dialog } from "@headlessui/react";
import { ModalFoterBox } from "../../components/box/Box";
import Button from "../../components/button/Button";
import { Modal, ModalProp } from "../../components/modal/Modal";
import { ConstMessage } from "../../config/const";

type Props = {
  text: String;
};

export const UserSearchModal = ({
  open,
  text,
  toggle,
  closeOnClickOutside
}: Props & ModalProp) => {
  return (
    <>
      <Modal
        open={open}
        toggle={toggle}
        closeOnClickOutside={closeOnClickOutside}
      >
        <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all">
          <div className="px-2 pb-4 sm:p-4">
            <div className="text-center sm:mt-3">
              <Dialog.Title
                as="h3"
                className="text-left text-lg font-medium leading-6 text-gray-900"
              >
                {}
              </Dialog.Title>
            </div>
            <div className="mt-5">
              {text}
            </div>
          </div>
          <ModalFoterBox>
            <Button
              className="mt-1"
              onClick={toggle}
              children={"閉じる"}
            />
          </ModalFoterBox>
        </Dialog.Panel>
      </Modal>
    </>
  );
}
